/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FormulaVariable } from './formula-name-resolver';
import { FormulaToken } from './formula-token';

export interface FormulaRewriteStrategy {
  rewriteVariableName(token: FormulaToken, variable: FormulaVariable): string;

  rewriteOtherToken(token: FormulaToken): string;
}

export class DBFormulaRewriteStrategy implements FormulaRewriteStrategy {

  rewriteVariableName(token: FormulaToken, variable: FormulaVariable): string {
    return `$TOP_WITH_ID_${variable.id}$`;
  }

  rewriteOtherToken(token: FormulaToken): string {
    return token.content;
  }
}
